export const AREAS_GLOSSARY = [
  {
    key: 'areas.stockVsUsage',
    label: 'Estoque × uso',
    whatIs: 'Estoque é o que existe no banco do cliente no dia do retrato: PDIs em andamento, ajustes pendentes, vagas abertas. Uso é o que as pessoas fizeram, medido pelos eventos: quem usou e com que frequência.',
    purpose: 'Responde "quantos existem agora" e "quantos estão parados", que os eventos de uso não respondem. Lido ao lado da adoção em Funcionalidades, estoque alto com pouco uso pode indicar trabalho acumulado.',
    howGenerated: 'Estoque: retrato noturno dos bancos dos clientes, uma vez por dia, às 23:30 (horário de Brasília). Uso: eventos processados a cada 15 minutos. São fontes diferentes e os números não se somam.',
    caveat: 'Métricas de 30 dias desta tela, como comunicados publicados em 30 dias, também são estoque: contam registros criados na janela, não ações medidas por eventos.',
    seeAlso: ['areas.total', 'areas.asOf'],
  },
  {
    key: 'areas.area',
    label: 'Área do produto',
    whatIs: 'Grupo de funcionalidades com um especialista próprio no Chat: Ponto e Jornada; Desenvolvimento de Pessoas; Comunicação Interna; Endomarketing, Clima e Benefícios; DP, Documentos e Assinaturas; e Recrutamento e Seleção.',
    purpose: 'Organiza o estoque por assunto, para ler de uma vez o que está em andamento, pendente ou atrasado em cada parte do produto e levar a dúvida ao especialista certo.',
    howGenerated: 'Definida no catálogo de áreas do PI, com as funcionalidades e as métricas de cada uma. Uma funcionalidade pode estar em mais de uma área, como a admissão online, em DP e em Recrutamento.',
  },
  {
    key: 'areas.metric',
    label: 'Métrica',
    whatIs: 'Contagem de um tipo de registro de uma área do produto, com uma regra fixa e, quando existe, a tela do produto em que o cliente vê o mesmo número para a empresa dele.',
    purpose: 'O nome abre o detalhe da métrica, com a série diária, os cortes por porte e por perfil da empresa e a lista de empresas.',
    howGenerated: 'A regra de cada métrica está no catálogo de áreas do PI e reproduz a regra da tela do produto quando ela existe; o retrato noturno aplica a regra em cada banco de clientes.',
    seeAlso: ['areas.definition'],
  },
  {
    key: 'areas.metricKey',
    label: 'Chave da métrica',
    whatIs: 'Código fixo da métrica no catálogo de áreas do PI, como pdi.active para PDIs em andamento.',
    purpose: 'Identifica a métrica sem depender do nome, para cruzar planilhas e citar a métrica ao especialista do Chat.',
    howGenerated: 'Definida no catálogo de áreas do PI; não muda quando o nome da métrica é ajustado.',
  },
  {
    key: 'areas.primary',
    label: 'Métrica principal',
    whatIs: 'A métrica de manchete de cada área, mostrada em destaque no cartão, como PDIs em andamento em Desenvolvimento de Pessoas.',
    purpose: 'Dá a leitura mais rápida da área; as outras métricas detalham o estoque.',
    howGenerated: 'Marcada no catálogo de áreas do PI: cada área tem exatamente uma métrica principal.',
  },
  {
    key: 'areas.definition',
    label: 'Definição',
    whatIs: 'A regra da métrica em português: o que entra na contagem, com status, datas e exclusões, e o que nunca é lido, como conteúdo de feedback ou respostas de pesquisa.',
    purpose: 'Permite conferir o número com a tela do produto e explicar ao cliente ou ao time o que está sendo contado.',
    howGenerated: 'Texto do catálogo de áreas do PI, escrito junto com a regra que o retrato noturno aplica nos bancos dos clientes.',
  },
  {
    key: 'areas.total',
    label: 'Total',
    whatIs: 'Soma da métrica em todas as empresas do recorte no último retrato, por exemplo o total de PDIs em andamento nas empresas ativas.',
    purpose: 'Dá o tamanho do estoque no produto inteiro ou no recorte escolhido, para acompanhar se o acumulado cresce ou diminui.',
    howGenerated: 'Às 23:30 (horário de Brasília) o retrato noturno lê cada banco de clientes e grava a contagem por empresa. Entram empresas ativas e não excluídas, fora as de demonstração e o ambiente de Portugal.',
    caveat: 'Em métrica sensível, o cartão, a taxa, a variação, a série e os cortes por porte e perfil contam só as empresas com 5 ou mais na base.',
    seeAlso: ['areas.companies', 'areas.sensitive'],
  },
  {
    key: 'areas.companies',
    label: 'Empresas',
    whatIs: 'Empresas do recorte com valor maior que zero na métrica no último retrato.',
    purpose: 'Mostra se o estoque está espalhado ou concentrado: mil PDIs em 3 empresas é diferente de mil PDIs em 300.',
    howGenerated: 'Conta as empresas com pelo menos um registro na regra da métrica no retrato noturno, dentro do universo e dos filtros de porte, perfil, jornada e trial.',
    caveat: 'Em métrica sensível, o cartão e os cortes por porte e perfil contam só as empresas com 5 ou mais na base.',
    seeAlso: ['areas.eligible', 'areas.share'],
  },
  {
    key: 'areas.eligible',
    label: 'Empresas que contrataram',
    whatIs: 'Empresas do recorte com a funcionalidade da métrica liberada no dia do retrato, valendo também a equivalente do catálogo, como Documentos e Documentos V2.',
    purpose: 'É a base da participação: mostra quantas das empresas que têm a funcionalidade poderiam ter estoque nela.',
    howGenerated: 'Mesma regra do estado das funcionalidades do PI: funcionalidade sem trava no catálogo vale para todas as empresas; com trava, vale o período liberado da empresa no dia do retrato.',
    caveat: 'Comunicados não dependem de funcionalidade contratada; nessas métricas o número não existe.',
    seeAlso: ['areas.share', 'areas.companiesWithFeature'],
  },
  {
    key: 'areas.companiesWithFeature',
    label: 'Com valor entre as que contrataram',
    whatIs: 'Empresas que contrataram a funcionalidade da métrica e têm valor maior que zero nela no último retrato.',
    purpose: 'É o numerador da participação. A diferença para Empresas mostra quem tem registros sem a funcionalidade liberada hoje, como dados antigos de quem deixou de contratar.',
    howGenerated: 'Cruza as empresas com valor no retrato noturno com as liberações da funcionalidade, ou da equivalente no catálogo, no dia do retrato.',
    caveat: 'Em métrica sensível, os cortes por porte e perfil não contam as empresas com menos de 5 na base.',
  },
  {
    key: 'areas.share',
    label: 'Participação',
    whatIs: 'Parte das empresas que contrataram a funcionalidade da métrica que têm valor maior que zero nela no último retrato. Aparece no cartão como "X% das que contrataram".',
    purpose: 'Mede o alcance entre quem tem a funcionalidade: 40% em PDIs em andamento quer dizer que 6 em cada 10 empresas com PDI liberado não têm nenhum PDI em andamento.',
    howGenerated: 'Com valor entre as que contrataram ÷ empresas que contrataram × 100, com duas casas, no retrato noturno e no mesmo recorte.',
    seeAlso: ['areas.eligible', 'areas.companiesWithFeature'],
  },
  {
    key: 'areas.delta7',
    label: 'Δ 7 dias',
    whatIs: 'Diferença entre o total do último retrato e o total do retrato de 7 dias antes: absoluta e, entre parênteses, em porcentagem.',
    purpose: 'Mostra se o estoque cresce ou diminui na semana. Em pendências, alta é acúmulo; queda é trabalho resolvido ou registro excluído.',
    howGenerated: 'Usa o retrato mais recente entre 7 e 10 dias antes do último, porque o retrato não roda todo dia. O total de antes usa as empresas do recorte naquele dia. Sem retrato nessa faixa, não aparece.',
    caveat: 'A porcentagem não aparece quando o total de antes é zero.',
    seeAlso: ['areas.delta28', 'areas.previous7'],
  },
  {
    key: 'areas.delta28',
    label: 'Δ 28 dias',
    whatIs: 'Diferença entre o total do último retrato e o total do retrato de 28 dias antes: absoluta e, entre parênteses, em porcentagem.',
    purpose: 'Mostra a tendência do mês sem o vaivém da semana, por exemplo se o acúmulo de ajustes pendentes é recente ou vem de longe.',
    howGenerated: 'Usa o retrato mais recente entre 28 e 31 dias antes do último, porque o retrato não roda todo dia. O total de antes usa as empresas do recorte naquele dia. Sem retrato nessa faixa, não aparece.',
    caveat: 'A porcentagem não aparece quando o total de antes é zero.',
    seeAlso: ['areas.delta7', 'areas.previous28'],
  },
  {
    key: 'areas.previous7',
    label: 'Total 7 dias antes',
    whatIs: 'Total da métrica no retrato usado para a comparação de 7 dias, com as empresas que estavam no recorte naquele dia.',
    purpose: 'Permite refazer a variação de 7 dias na planilha e ver de onde o número partiu.',
    howGenerated: 'É o total do retrato mais recente entre 7 e 10 dias antes do último. Fica vazio quando não há retrato nessa faixa.',
    seeAlso: ['areas.delta7'],
  },
  {
    key: 'areas.previous28',
    label: 'Total 28 dias antes',
    whatIs: 'Total da métrica no retrato usado para a comparação de 28 dias, com as empresas que estavam no recorte naquele dia.',
    purpose: 'Permite refazer a variação de 28 dias na planilha e ver de onde o número partiu.',
    howGenerated: 'É o total do retrato mais recente entre 28 e 31 dias antes do último. Fica vazio quando não há retrato nessa faixa.',
    seeAlso: ['areas.delta28'],
  },
  {
    key: 'areas.rate',
    label: 'Taxa',
    whatIs: 'Proporção entre duas contagens da mesma área, nas métricas que têm partes: taxa de leitura dos comunicados, adesão às pesquisas, taxa de resposta das avaliações e a parte de cada humor nas respostas.',
    purpose: 'Compara engajamento entre recortes e ao longo do tempo sem depender do tamanho das empresas.',
    howGenerated: 'Soma do numerador ÷ soma do denominador × 100, com duas casas, em todas as empresas do recorte no último retrato. As partes de cada taxa estão na fórmula e na definição da métrica.',
    caveat: 'É a taxa do recorte inteiro, não a média das taxas das empresas: empresas grandes pesam mais. Na definição do humor, a taxa aparece com o nome de participação.',
    seeAlso: ['areas.numerator', 'areas.denominator', 'areas.companyRate'],
  },
  {
    key: 'areas.numerator',
    label: 'Numerador',
    whatIs: 'Contagem de cima da taxa da métrica, como respondentes de uma pesquisa ou leituras de comunicados.',
    purpose: 'Junto com o denominador, mostra de quantos registros a taxa sai: 50% de 4 pessoas não pesa como 50% de 400.',
    howGenerated: 'Soma das métricas do numerador definidas no catálogo de áreas, lidas no retrato noturno, no total do recorte ou na empresa da linha.',
    seeAlso: ['areas.denominator', 'areas.rate'],
  },
  {
    key: 'areas.denominator',
    label: 'Denominador',
    whatIs: 'Contagem de baixo da taxa da métrica, como convidados de uma pesquisa ou destinatários de comunicados.',
    purpose: 'Mostra o tamanho da base da taxa; com denominador pequeno, a taxa muda muito com uma pessoa.',
    howGenerated: 'Soma das métricas do denominador definidas no catálogo de áreas, lidas no retrato noturno, no total do recorte ou na empresa da linha.',
    seeAlso: ['areas.numerator', 'areas.rate'],
  },
  {
    key: 'areas.companyRate',
    label: 'Taxa da empresa',
    whatIs: 'A taxa da métrica calculada só com os números da empresa, como a adesão às pesquisas de clima abertas dela.',
    purpose: 'Acha empresas com engajamento muito acima ou abaixo do total, para o time de sucesso do cliente agir.',
    howGenerated: 'Numerador ÷ denominador da empresa × 100 no retrato noturno. Fica vazia quando o denominador é zero; ao ordenar por ela, as empresas sem taxa ficam no fim da ordem decrescente e no começo da crescente.',
    seeAlso: ['areas.rate'],
  },
  {
    key: 'areas.state',
    label: 'Estado',
    whatIs: 'Situação do número da métrica: Medido, quando todos os bancos com empresas no recorte foram lidos; Parcial, quando algum ficou de fora; n/d, antes do primeiro retrato das áreas.',
    purpose: 'Diz se o total está completo antes de usar o número numa decisão.',
    howGenerated: 'Calculado a partir da cobertura do último retrato: banco sem leitura, com leitura que falhou ou desatualizada, ou sem o índice que a métrica exige deixa a métrica Parcial.',
    seeAlso: ['areas.partial', 'areas.coverage'],
  },
  {
    key: 'areas.partial',
    label: 'Parcial',
    whatIs: 'Algum banco de clientes com empresas no recorte não foi lido no último retrato, ou faltou nele o índice que a métrica exige: as empresas desse banco ficam fora do total.',
    purpose: 'Avisa que o número está menor do que o real e mostra qual banco falta, para não comparar com um retrato completo.',
    howGenerated: 'O PI confere as marcas de leitura de cada área e banco gravadas pelo retrato noturno. O motivo aparece ao passar o mouse sobre o selo e na cobertura por banco.',
    caveat: 'Normalmente se resolve no retrato da noite seguinte; um índice ausente só se resolve com a criação do índice no banco.',
    seeAlso: ['areas.coverage'],
  },
  {
    key: 'areas.stateReason',
    label: 'Motivo do estado',
    whatIs: 'Os bancos que deixaram a métrica Parcial: sem leitura no último retrato ou sem o índice que a métrica exige.',
    purpose: 'Diz exatamente quais empresas faltam no total, pelo banco em que elas estão.',
    howGenerated: 'Montado a partir das marcas de leitura do retrato noturno para a área e para os índices de cada banco.',
  },
  {
    key: 'areas.asOf',
    label: 'Dados de',
    whatIs: 'Data e hora em que o PI leu os bancos dos clientes para montar o último retrato das áreas.',
    purpose: 'Diz quão recente é o estoque: um PDI criado depois desse horário só aparece no retrato da noite seguinte.',
    howGenerated: 'É o início da leitura do retrato noturno, que roda às 23:30 (horário de Brasília). Com várias métricas ou áreas, vale o horário mais recente entre elas.',
    caveat: 'O retrato lido às 23:30 recebe a data do dia anterior, como o retrato das empresas; por isso a série termina um dia antes de "Dados de".',
    seeAlso: ['areas.snapshotDate'],
  },
  {
    key: 'areas.snapshotDate',
    label: 'Data do retrato',
    whatIs: 'Data que identifica cada retrato noturno das áreas, usada na série diária e nas comparações de 7 e 28 dias.',
    purpose: 'Permite comparar o estoque entre dias e achar o dia em que um número mudou.',
    howGenerated: 'O retrato lido às 23:30 (horário de Brasília) recebe a data do dia anterior, a mesma regra do retrato das empresas. Dia sem retrato não aparece na série.',
    seeAlso: ['areas.asOf'],
  },
  {
    key: 'areas.series',
    label: 'Série diária',
    whatIs: 'Total e empresas com valor em cada retrato das áreas, do primeiro retrato até o último, em até 400 dias.',
    purpose: 'Mostra a tendência do estoque: se o acúmulo é recente ou antigo e se uma mudança veio de um dia só.',
    howGenerated: 'Cada ponto usa as empresas do universo e do recorte no retrato das empresas da mesma data. Em métrica sensível, cada ponto conta só as empresas com 5 ou mais na base naquele dia.',
    caveat: 'A cobertura por banco vale só para o último retrato; um ponto antigo pode ter um banco sem leitura sem aviso.',
    seeAlso: ['areas.snapshotDate', 'areas.total'],
  },
  {
    key: 'areas.sensitive',
    label: 'Métrica sensível',
    whatIs: 'Métrica que poderia expor pessoas em empresas pequenas, como a distribuição dos humores e quem respondeu uma pesquisa.',
    purpose: 'Protege a privacidade: o número de uma empresa só aparece quando a base dela tem 5 ou mais pessoas.',
    howGenerated: 'Empresa com menos de 5 na base da métrica (convidados da pesquisa ou pessoas que responderam o humor) fica fora de todos os números: lista por empresa, cortes, total, participação, taxa, variação e série. O aviso diz quantas empresas têm de 1 a 4 na base.',
  },
  {
    key: 'areas.coverage',
    label: 'Cobertura por banco',
    whatIs: 'Situação da leitura de cada área em cada banco de clientes no último retrato: lido, lido sem índice, falhou, desatualizado ou sem leitura.',
    purpose: 'Mostra se o total está completo: um banco sem leitura deixa as empresas dele fora do número, e a métrica fica Parcial.',
    howGenerated: 'Vem das marcas que o retrato noturno grava por área e banco, com a data do retrato lido, o horário da última execução e o erro, quando houver.',
    seeAlso: ['areas.coverageStatus', 'areas.partial'],
  },
  {
    key: 'areas.coverageStatus',
    label: 'Situação da leitura',
    whatIs: 'Lido: a área foi contada no banco. Lido sem índice: faltou um índice e as métricas que dependem dele ficaram fora. Falhou: deu erro. Desatualizado: só há leitura de retrato anterior. Sem leitura: nunca foi lida.',
    purpose: 'Ajuda a decidir se dá para confiar no total da área ou se é preciso esperar a noite seguinte ou acionar o time técnico.',
    howGenerated: 'Marca gravada pelo retrato noturno para a área e o banco. Leituras pesadas só rodam com o índice conferido no banco; sem ele, a métrica fica fora em vez de pesar no banco do cliente.',
    seeAlso: ['areas.coverage'],
  },
  {
    key: 'areas.coverageCompanies',
    label: 'Empresas no recorte',
    whatIs: 'Empresas do universo e dos filtros da tela que estão em cada banco no último retrato.',
    purpose: 'Mostra o peso de cada banco: um banco sem leitura com muitas empresas pesa mais no total.',
    howGenerated: 'Contadas no retrato noturno das empresas, com a regra do universo das áreas e os filtros de porte, perfil, jornada e trial.',
  },
  {
    key: 'areas.rank',
    label: 'Posição',
    whatIs: 'Posição da empresa na ordem escolhida, contando as páginas anteriores.',
    purpose: 'Situa a empresa no recorte, por exemplo entre as 10 com mais ajustes pendentes.',
    howGenerated: 'Numerada pelo PI na ordem da lista; nos empates, desempata pelo valor e depois pelo nome da empresa.',
  },
  {
    key: 'areas.companyValue',
    label: 'Valor',
    whatIs: 'Contagem da métrica na empresa no último retrato, como os PDIs em andamento dela.',
    purpose: 'Ordena as empresas pelo tamanho do estoque, para priorizar quem mais acumula ou mais usa a área.',
    howGenerated: 'Mesma regra da métrica aplicada aos registros da empresa no retrato noturno. A lista traz as empresas com valor maior que zero e, nas métricas com taxa, também as com denominador maior que zero.',
    seeAlso: ['areas.companyRate'],
  },
  {
    key: 'areas.featureEnabled',
    label: 'Contratou',
    whatIs: 'Se a empresa tinha a funcionalidade da métrica, ou a equivalente do catálogo, liberada no dia do retrato.',
    purpose: 'Separa estoque de quem tem a funcionalidade de registros que sobraram de quem deixou de contratar.',
    howGenerated: 'Mesma regra do estado das funcionalidades do PI: sem trava no catálogo, vale para todas; com trava, vale o período liberado da empresa no dia do retrato.',
    seeAlso: ['areas.eligible'],
  },
  {
    key: 'areas.isTrial',
    label: 'Em trial',
    whatIs: 'Se a empresa estava em período de teste no último retrato.',
    purpose: 'Separa estoque de quem ainda avalia o produto, que pode ser dado de demonstração do teste, do estoque de cliente pagante.',
    howGenerated: 'Lido da marca de trial do cadastro da empresa no retrato noturno das empresas.',
    seeAlso: ['areas.filter.trial'],
  },
  {
    key: 'areas.profile',
    label: 'Porte, perfil e jornada',
    whatIs: 'Porte pelo número de funcionários, perfil da empresa gravado no Master, etapa da jornada do cliente e o selo Trial quando a empresa está em teste.',
    purpose: 'Ajuda a comparar empresas parecidas e a priorizar o contato pela etapa da jornada.',
    howGenerated: 'Lidos do retrato noturno das empresas no dia do último retrato das áreas. Na exportação, cada um vai numa coluna.',
    seeAlso: ['common.sizeBand', 'common.segment', 'common.journey'],
  },
  {
    key: 'areas.filter.sizeBand',
    label: 'Porte (funcionários)',
    whatIs: 'Restringe às empresas de uma faixa de tamanho pelo número de funcionários do cadastro: A (100 ou mais), B (50 a 99), C (21 a 49), D (11 a 20) e E (até 10).',
    purpose: 'Compara o estoque de empresas parecidas, já que contas grandes acumulam mais registros.',
    howGenerated: 'Lido do retrato das empresas: o total usa o porte do dia do último retrato e cada ponto da série, o do seu dia. Combina com perfil, jornada e trial.',
    caveat: 'É o mesmo filtro de porte das outras abas do PI: a escolha vale também nelas.',
    seeAlso: ['common.sizeBand'],
  },
  {
    key: 'areas.filter.segment',
    label: 'Perfil da empresa',
    whatIs: 'Restringe às empresas com uma categoria comercial, de A a E, gravada no Master (o "Perfil" do detalhe da empresa). Digite a letra como no cadastro.',
    purpose: 'Lê o estoque por categoria de cliente, a mesma que o comercial e o time de sucesso do cliente usam para priorizar.',
    howGenerated: 'Compara o texto inteiro com o perfil do retrato das empresas, no dia do último retrato e em cada ponto da série. Combina com porte, jornada e trial.',
    caveat: 'É o mesmo filtro de perfil das outras abas do PI: a escolha vale também nelas.',
    seeAlso: ['common.segment'],
  },
  {
    key: 'areas.filter.journey',
    label: 'Jornada',
    whatIs: 'Restringe às empresas numa etapa da jornada do cliente gravada no Master: Lead, Onboarding, Middle, Ongoing ou Resale.',
    purpose: 'Compara o estoque entre etapas, por exemplo PDIs ou pesquisas em empresas em Onboarding contra Ongoing.',
    howGenerated: 'Lida do retrato das empresas, no dia do último retrato e em cada ponto da série. O PI não calcula a jornada: mostra o que o time gravou.',
    caveat: 'Vale só em Áreas e no detalhe da métrica; não muda as outras abas do PI.',
    seeAlso: ['common.journey'],
  },
  {
    key: 'areas.filter.trial',
    label: 'Trial',
    whatIs: 'Inclui ou separa as empresas em período de teste: com e sem trial (padrão), sem as empresas em trial ou só as empresas em trial.',
    purpose: 'Tira do estoque quem ainda avalia o produto, cujos registros podem ser dados de demonstração, ou olha só para essas empresas.',
    howGenerated: 'Usa a marca de trial do retrato das empresas, no dia do último retrato e em cada ponto da série.',
    caveat: 'Não é o filtro "Trial antes da venda" da Ativação: os dois usam a mesma chave no endereço, e cada aba ignora o valor da outra.',
    seeAlso: ['areas.isTrial'],
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/areas.js